module.exports = __webpack_public_path__ + "img/building12.647aac83.jpg";